import type { CompanyStatus } from '@planuze/admin-contracts';
import { COMPANIES_CONTENT } from '../../content/sections/companies.js';

type Tone = 'success' | 'warning' | 'destructive';

/* Mapeamento status → tom do StatusBadge, compartilhado entre a tabela e o header de detalhe.
   O tom é puro layout (não é texto) — não entra no catálogo bilíngue. */
export function statusTone(status: CompanyStatus): Tone {
  switch (status) {
    case 'active':
      return 'success';
    case 'trial':
      return 'warning';
    case 'blocked':
      return 'destructive';
  }
}

/**
 * Rótulo do status no idioma corrente.
 *
 * `labels` é `useCompaniesContent().status`; o default pt-BR cobre chamadores fora de
 * componente (testes unitários).
 */
export function statusLabel(
  status: CompanyStatus,
  labels: Readonly<Record<CompanyStatus, string>> = COMPANIES_CONTENT['pt-BR'].status,
): string {
  return labels[status];
}
